import styled, { css, ThemeProvider, useTheme } from "styled-components"
import type { ComponentType } from "react"
import {
  Pressable,
  ScrollView,
  Image,
  TextInput,
  SafeAreaView,
  FlatList,
  SectionList,
  Modal,
  ImageBackground,
} from "./primitives"
import { TouchButton, TouchableView } from "./touchable"
import { WebText } from "./web-text"
import { shouldForwardProp } from "./dom-props"

const withConfig = <C extends ComponentType>(component: C) =>
  styled(component).withConfig({ shouldForwardProp })

/** H5：View/Text/Touchable 映射为原生 DOM + React 事件 */
const styledNative = Object.assign(styled, {
  View: styled.div.withConfig({ shouldForwardProp }),
  Text: withConfig(WebText),
  Pressable: withConfig(Pressable),
  TouchableOpacity: withConfig(TouchButton),
  TouchableWithoutFeedback: withConfig(TouchableView),
  TouchableHighlight: withConfig(TouchButton),
  ScrollView: withConfig(ScrollView),
  FlatList: withConfig(FlatList),
  SectionList: withConfig(SectionList),
  Image: withConfig(Image),
  ImageBackground: withConfig(ImageBackground),
  TextInput: withConfig(TextInput),
  SafeAreaView: withConfig(SafeAreaView),
  Modal: withConfig(Modal),
  KeyboardAvoidingView: styled.div.withConfig({ shouldForwardProp }),
  button: withConfig(TouchButton),
  span: styled.span.withConfig({ shouldForwardProp }),
  div: styled.div.withConfig({ shouldForwardProp }),
})

export { css, ThemeProvider, useTheme }
export default styledNative
